const IDLE_TIMEOUT_MS = 700;
const FALLBACK_DELAY_MS = 180;

export interface HomepageWarmupEnvironment {
  requestIdleCallback?: Window['requestIdleCallback'];
  cancelIdleCallback?: Window['cancelIdleCallback'];
  setTimeout: Window['setTimeout'];
  clearTimeout: Window['clearTimeout'];
}

/**
 * Table selection should stay responsive while optional image/audio warmup is
 * opportunistic. Defer that work until the browser is idle, and make the
 * pre-start task cancellable so quickly browsing the carousel does not warm
 * every intermediate machine.
 */
export function scheduleHomepageWarmup(
  start: () => void,
  environment: HomepageWarmupEnvironment,
): () => void {
  let active = true;
  const run = () => {
    if (active) start();
  };

  if (environment.requestIdleCallback) {
    const handle = environment.requestIdleCallback(run, { timeout: IDLE_TIMEOUT_MS });
    return () => {
      active = false;
      environment.cancelIdleCallback?.(handle);
    };
  }

  const handle = environment.setTimeout(run, FALLBACK_DELAY_MS);
  return () => {
    active = false;
    environment.clearTimeout(handle);
  };
}
